import { createTheme } from "@mui/material";

const theme = createTheme({
  // defining breakpoints as per the new design
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 905,
      lg: 1240,
      xl: 1440,
      xxl: 2560,
    },
  },
  typography: {
    fontFamily: ["Poppins"].join(","),
    aigHeading1: {
      fontSize: "1.5rem",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "2.25rem",
      letterSpacing: "0.03rem",
      color: "#071E54",
    },
    aigHeading2: {
      fontSize: "1.25rem",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "2rem",
      letterSpacing: "0.03rem",
    },
    aigHeading3: {
      fontSize: "1.125rem",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "1.25rem",
      letterSpacing: "-0.0125rem",
    },
    aigBodyL: {
      fontSize: "1rem",
      fontStyle: "normal",
      lineHeight: "1.25rem",
    },
    aigBodyM: {
      fontSize: "0.875rem",
      fontStyle: "normal",
      lineHeight: "1.25rem",
      letterSpacing: "0.0175rem",
    },
    aigBodyS: {
      fontSize: "0.75rem",
      fontStyle: "normal",
      lineHeight: "0.875rem",
    },
    aigBodyXS: {
      fontSize: "0.625rem",
      fontStyle: "normal",
      lineHeight: "1.25rem",
    },
    overlineS: {
      fontSize: "0.75rem",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "0.875rem",
      letterSpacing: "0.06rem",
      textTransform: "uppercase",
    },
    // fontWeightLight: "300",
    // fontWeightRegular: "400",
    // fontWeightMedium: "500",

    headerLinkStyle: {
      fontSize: "12px",
      fontWeight: 400,
      cursor: "pointer",
      borderBottom: "2px solid transparent",
      "&:hover": {
        fontSize: "12px",
        fontWeight: 600,
        color: "#055CA8",
      },
    },
    button: {
      textTransform: "none",
    },
    defaultText: {
      fontSize: "1rem",
    },
  },
  palette: {
    background: {
      default: "#fff !important",
      secondary: "#264A9F",
      white: "#ffffff",
      border: "#9E9E9E",
      gray: "#E8EDFF",
      snackbar: "rgba(0, 0, 0, 0.87)",
      greyBackground: "#ECF2FF",
      reviewIcons: "#FFC147B5",
      rejectIcon: "#E94C4C90",
      bubbles: "#E9FCFF",
      verdigris: "#4EACB5",
      sliderBackground: "rgba(181, 187, 202, 0.20)",
      diamond: "#C1F4FA",
      mediumSkyBlue: "#88DEEC",
      water: "#C9E6FF",
    },
    color: {
      aigColor1: "#055CA8",
      aigColor2: "#38495C",
      aigColor3: "#8A94A7",
      aigColor4: "#425262",
      aigColor5: "#E1E1E4",
      aigColor6: "#323338",
      aigColor7: "#071E54",
      aigColor8: "#97D8F6",
      aigColor9: "#378DCA",
      aigColor10: "#264A9F",
      aigColor11: "#000000",
      aigColor15: "#C5C7D0",
      aigColor16: "#4DA05D",
      aigColor17: "#7EBD7B",
      aigColor18: "#E9FCFF",
      aigColor19: "#D7DADF",
      aigColor20: "#4EACB5",
      aigColor21: "#D26252",
      aigColor22: "#C1F4FA",
      aigColor23: "#6CBAFF",
      aigColor24: "#C9E6FF",
      aigColor25: "#88DEEC",
      aigColor26: "#252525",
      aigColor27: "#F7F6FB",
      aigColor28: "#fff",
      aigColor29: "#EBEDF0",
      aigColor31: "#EBEDF0",
      aigColor32: "#70B57D",
      aigColor33: "#4D95D4",
      aigColor34: "#23A26D",
      aigColor35: "#008000",
      aigColor36: "#D6902E",
      aigColor37: "#ffffff",
      aigColor38: "#626365",
      aigColor41: "#ADB0B6",
      aigColor42: "#FF0000",
      aigColor43: "#252525",
      aigColor44: "#606060",
      aigColor51: "#D18316",
      aigColor52: "#378DCA",
      aigColor53: "#B24434",
      aigColor54: "#F5F6F8",
      aigColor55: "#FFE3DF",
      aigColor56: "#A6AAB6",
      aigColor57: "#3B3636",
      aigColor58: "#CACACA",
      aigColor59: "#00000099",
      aigColor60: "#D32F2F",
      aigColor61: "#2FAC24",
      aigColor62: "#F8F8F8",
      aigColor63: "#141212",
      aigColor64: "#C7D0E6",
      aigColor65: "rgba(0, 0, 0, 0.6)",
      aigColor66: "#D1D1D1",
      aigColor67: "#626262",
      aigColor68: "#CBCBCB",
      aigColor69: "#00000061",
      aigColor70: "#BA5748",
      aigColor71: "#57B9E7",
      aigColor72: "#F0F7FF",
      aigColor73: "#D9D9D9",
      aigColor74: "#F5F5F5",
      aigColor75: "#F04D4B",
      aigColor76: "#D6902E",
      aigWarning: "#FCF1D9",
      aigSuccess: "#DCF2E0",
      darkGreen: "#4DA05D",
      brightGray: "#EBEDF0",
      iguanaGreen: "#7EBD7B ",
      aigColor77: "#e0e0e0",
    },
    shadow: {
      header: "0px 2px 8px 0px rgba(56, 73, 92, 0.06)",
      mobileStepper: "inset 0 0 1px 5px #DBDBDB",
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: "red",
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "aig-primary" },
          style: {
            backgroundColor: "#055CA8",
            color: "white",
            borderRadius: "1.5rem",
            ":disabled": {
              background: "#A6AAB6",
              color: "white",
            },
            ":hover": { backgroundColor: "#055CA8" },
          },
        },
        {
          props: { variant: "aig-outlined" },
          style: {
            backgroundColor: "transparent",
            color: "#055CA8",
            border: "1px solid #055CA8",
            borderRadius: "1.5rem",
            ":hover": { backgroundColor: "transparent" },
          },
        },
        {
          props: { variant: "aig-text" },
          style: {
            backgroundColor: "transparent",
            color: "#055CA8",
            ":hover": { backgroundColor: "transparent" },
          },
        },
      ],
    },
  },
});

export default theme;
